import { useUsersQuery, UseUsersQueryParams } from "../queries/useUsersQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { UserInterface } from "../../../interfaces/userInterface";

type Response = {
  users: UserInterface[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useUsers = (opt: UseUsersQueryParams): Response => {
  const { data, isLoading } = useUsersQuery(opt);
  return {
    users: data?.data?.users || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
